import { render, staticRenderFns } from "./Portifolio.vue?vue&type=template&id=92678630&scoped=true&"
import script from "./Portifolio.vue?vue&type=script&lang=js&"
export * from "./Portifolio.vue?vue&type=script&lang=js&"
import style0 from "./Portifolio.vue?vue&type=style&index=0&id=92678630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92678630",
  null
  
)

export default component.exports